(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fahrzeug-waehler"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const waehler = document.querySelector('[data-waehler]');
    if (!waehler) return;

    // Die Fahrzeuge stehen als fertig gerenderte Karten in der Seite. Von
    // hier aus werden sie nur noch verschoben, nicht neu gebaut.
    const vorrat = document.querySelector('[data-vorrat]');
    if (!vorrat) return;

    const fahrzeuge = [...vorrat.querySelectorAll('.eintrag')].map((el) => ({
      el,
      marke: el.dataset.marke,
      modell: el.dataset.modell,
      baujahr: el.dataset.baujahr,
    }));

    const stand = { marke: null, modell: null, baujahr: null };
    const ergebnis = waehler.querySelector('[data-ergebnis]');
    const ergebnisListe = waehler.querySelector('[data-erg-liste]');

    const feld = (name) => waehler.querySelector(`[data-schritt="${name}"]`);
    const ziel = (name) => waehler.querySelector(`[data-ziel="${name}"]`);

    const einzeln = (werte) => [...new Set(werte.filter(Boolean))].sort((a, b) => a.localeCompare(b, 'de'));

    const passend = () =>
      fahrzeuge.filter(
        (f) =>
          (!stand.marke || f.marke === stand.marke) &&
          (!stand.modell || f.modell === stand.modell) &&
          (!stand.baujahr || f.baujahr === stand.baujahr)
      );

    const kacheln = (name, werte, beiWahl) => {
      const behaelter = ziel(name);
      behaelter.replaceChildren();
      werte.forEach((wert) => {
        const knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'wahlzeile';

        const beschriftung = document.createElement('span');
        beschriftung.textContent = wert;

        const pfeil = document.createElement('span');
        pfeil.className = 'wahlzeile__pfeil';
        pfeil.textContent = '›';
        pfeil.setAttribute('aria-hidden', 'true');

        knopf.append(beschriftung, pfeil);
        knopf.addEventListener('click', () => beiWahl(wert));
        behaelter.appendChild(knopf);
      });
    };

    const zusammenfassen = (name, wert) => {
      const zeile = waehler.querySelector(`[data-gewaehlt="${name}"]`);
      const aendern = waehler.querySelector(`[data-zurueck="${name}"]`);
      if (!zeile) return;
      if (wert) {
        zeile.textContent = wert;
        zeile.hidden = false;
        ziel(name).hidden = true;
        if (aendern) aendern.hidden = false;
      } else {
        zeile.hidden = true;
        ziel(name).hidden = false;
        if (aendern) aendern.hidden = true;
      }
    };

    const freigeben = (name, an) => {
      feld(name).classList.toggle('schritt--aus', !an);
    };

    const verstecken = () => {
      // Alles zurück in den Vorrat, sonst sammeln sich bei jedem Wechsel
      // Karten aus früheren Auswahlen in der Ergebnisliste an.
      fahrzeuge.forEach((f) => vorrat.appendChild(f.el));
      ergebnis.setAttribute('hidden', '');
    };

    const zeigeErgebnis = () => {
      const treffer = passend();
      if (!treffer.length) {
        verstecken();
        return;
      }

      fahrzeuge.forEach((f) => vorrat.appendChild(f.el));
      treffer.forEach((t) => ergebnisListe.appendChild(t.el));

      const fahrzeugname = [stand.marke, stand.modell, stand.baujahr]
        .filter(Boolean)
        .join(' · ');
      waehler.querySelector('[data-erg-fahrzeug]').textContent = fahrzeugname;

      const mehrere = treffer.length > 1;
      const t = ergebnis.dataset;
      waehler.querySelector('[data-erg-titel]').textContent = mehrere
        ? (t.titelMehrere || '').replace('{anzahl}', treffer.length)
        : t.titelEine || '';
      waehler.querySelector('[data-erg-text]').textContent = mehrere
        ? t.textMehrere || ''
        : t.textEine || '';

      ergebnis.hidden = false;
      ergebnis.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    const baueMarken = () => {
      kacheln('marke', einzeln(fahrzeuge.map((f) => f.marke)), (wert) => {
        stand.marke = wert;
        stand.modell = null;
        stand.baujahr = null;
        zusammenfassen('marke', wert);
        zusammenfassen('modell', null);
        verstecken();
        freigeben('modell', true);
        freigeben('baujahr', false);
        ziel('baujahr').replaceChildren();
        baueModelle();
      });
    };

    const baueModelle = () => {
      kacheln('modell', einzeln(passend().map((f) => f.modell)), (wert) => {
        stand.modell = wert;
        stand.baujahr = null;
        zusammenfassen('modell', wert);
        verstecken();

        const jahre = einzeln(passend().map((f) => f.baujahr));
        if (jahre.length === 0) {
          // Nur eine Ausführung: Baujahr ist keine Frage.
          freigeben('baujahr', false);
          zeigeErgebnis();
          return;
        }
        freigeben('baujahr', true);
        baueJahre(jahre);
      });
    };

    const baueJahre = (jahre) => {
      kacheln('baujahr', jahre, (wert) => {
        stand.baujahr = wert;
        zusammenfassen('baujahr', wert);
        zeigeErgebnis();
      });
    };

    waehler.querySelectorAll('[data-zurueck]').forEach((knopf) => {
      knopf.addEventListener('click', () => {
        const stufe = knopf.dataset.zurueck;
        if (stufe === 'marke') {
          stand.marke = null;
          stand.modell = null;
          stand.baujahr = null;
          zusammenfassen('marke', null);
          zusammenfassen('modell', null);
          freigeben('modell', false);
          freigeben('baujahr', false);
          ziel('modell').replaceChildren();
          ziel('baujahr').replaceChildren();
          verstecken();
          baueMarken();
        } else if (stufe === 'modell') {
          stand.modell = null;
          stand.baujahr = null;
          zusammenfassen('modell', null);
          zusammenfassen('baujahr', null);
          freigeben('baujahr', false);
          ziel('baujahr').replaceChildren();
          verstecken();
          baueModelle();
        } else if (stufe === 'baujahr') {
          stand.baujahr = null;
          zusammenfassen('baujahr', null);
          verstecken();
          baueJahre(einzeln(passend().map((f) => f.baujahr)));
        }
      });
    });

    baueMarken();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const kopf = document.querySelector('[data-kopf]');
    if (!kopf) return;

    // Schwebende Leiste wird beim Scrollen fest — und wechselt dabei das
    // Farbschema, damit Wortmarke und Navigation immer lesbar bleiben.
    if (kopf.classList.contains('kopf--schwebend')) {
      const schwebend = kopf.dataset.schemaSchwebend;
      const fest = kopf.dataset.schemaFest;

      const pruefen = () => {
        const istFest = window.scrollY > 32;
        kopf.classList.toggle('kopf--fest', istFest);
        if (schwebend === fest) return;
        kopf.classList.toggle(fest, istFest);
        kopf.classList.toggle(schwebend, !istFest);
      };

      addEventListener('scroll', pruefen, { passive: true });
      pruefen();
    }

    const schalter = kopf.querySelector('[data-menue-schalter]');
    const klapp = kopf.querySelector('[data-menue]');
    if (!schalter || !klapp) return;

    schalter.addEventListener('click', () => {
      const offen = schalter.getAttribute('aria-expanded') === 'true';
      schalter.setAttribute('aria-expanded', String(!offen));
      klapp.hidden = offen;
      // Solange das Menü offen ist, soll die Leiste nicht durchsichtig sein.
      kopf.classList.toggle('kopf--fest', !offen);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formular = document.querySelector('.produkt__formular');
    if (!formular) return;

    const auswahl = formular.querySelector('[data-varianten]');
    const knoepfe = [...formular.querySelectorAll('.wahl__feld input')];
    if (!auswahl || !knoepfe.length) return;

    // Aus den gewählten Optionen die passende Variante bestimmen. Shopify
    // setzt den Variantentitel aus den Optionswerten mit „ / “ zusammen.
    const abgleichen = () => {
      const gewaehlt = [];
      knoepfe
        .filter((k) => k.checked)
        .forEach((k) => {
          gewaehlt[Number(k.dataset.position) - 1] = k.value;
        });

      const gesucht = gewaehlt.join(' / ');
      const treffer = [...auswahl.options].find((o) => o.dataset.titel === gesucht);
      if (!treffer) return;

      auswahl.value = treffer.value;
      auswahl.dispatchEvent(new Event('change', { bubbles: true }));

      // Der Preis oben muss mitwandern. Sonst steht dort weiter der Preis
      // ohne Einbau, während unten die Variante mit Einbau gewählt ist.
      const preis = document.querySelector('[data-preis]');
      if (preis && treffer.dataset.preis) preis.textContent = treffer.dataset.preis;
    };

    knoepfe.forEach((k) => k.addEventListener('change', abgleichen));
  })();

  } catch(e) { console.error(e); }
})();
})();
